export type FontWeightName = "regular" | "medium" | "semibold" | "bold";

export type TypeScaleKey =
  | "text-xs"
  | "text-sm"
  | "text-md"
  | "text-lg"
  | "text-xl"
  | "display-xs"
  | "display-sm"
  | "display-md"
  | "display-lg"
  | "display-xl"
  | "display-2xl";

export interface TypeScaleDef {
  size: string; // e.g. "14px"
  lineHeight: string; // e.g. "20px"
  tracking?: string; // e.g. "-0.01em"
}

export interface TypographyConfig {
  fontFamily: {
    sans: string;
    mono?: string;
  };
  fontWeight: Record<FontWeightName, number>;
  scales: Record<TypeScaleKey, TypeScaleDef>;
}

// Figma Typography System'e tam uyumlu konfigürasyon
export const typography: TypographyConfig = {
  fontFamily: {
    sans: 'Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  scales: {
    // Text Scales - Figma'dan gelen exact değerler
    "text-xs": { size: "12px", lineHeight: "18px" },
    "text-sm": { size: "14px", lineHeight: "20px" },
    "text-md": { size: "16px", lineHeight: "24px" },
    "text-lg": { size: "18px", lineHeight: "28px" },
    "text-xl": { size: "20px", lineHeight: "30px" },

    // Display Scales - Figma'dan gelen exact değerler
    "display-xs": { size: "24px", lineHeight: "32px" },
    "display-sm": { size: "30px", lineHeight: "38px" },
    "display-md": { size: "36px", lineHeight: "44px", tracking: "-0.02em" },
    "display-lg": { size: "48px", lineHeight: "60px", tracking: "-0.02em" },
    "display-xl": { size: "60px", lineHeight: "72px", tracking: "-0.02em" },
    "display-2xl": { size: "72px", lineHeight: "90px", tracking: "-0.02em" },
  },
};

export const writeTypographyVars = (
  root: HTMLElement,
  config: TypographyConfig
) => {
  // Font family
  root.style.setProperty("--font-sans", config.fontFamily.sans);
  if (config.fontFamily.mono) {
    root.style.setProperty("--font-mono", config.fontFamily.mono);
  }

  // Font weights
  Object.entries(config.fontWeight).forEach(([name, weight]) => {
    root.style.setProperty(`--font-weight-${name}`, String(weight));
  });

  // Scales
  Object.entries(config.scales).forEach(([key, def]) => {
    const safe = key.replace(/[^a-z0-9-]/gi, "").toLowerCase();
    root.style.setProperty(`--font-size-${safe}`, def.size);
    root.style.setProperty(`--line-height-${safe}`, def.lineHeight);
    if (def.tracking) {
      root.style.setProperty(`--tracking-${safe}`, def.tracking);
    }
  });
};
